"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.install = exports._Vue = void 0;
var directive_1 = require("./directive");
var installed = false;
var install = function (Vue) {
    if (installed && exports._Vue === Vue)
        return;
    installed = true;
    exports._Vue = Vue;
    var isDef = function (v) { return v !== undefined; };
    Vue.mixin({
        beforeCreate: function () {
            if (isDef(this.$options.monitor)) {
                this._monitorRoot = this;
                this._monitor = this.$options.monitor;
                this._monitor.init(this);
            }
            else {
                this._monitorRoot = (this.$parent && this.$parent._monitorRoot) || this;
            }
        },
    });
    Vue.use(directive_1.directive);
    Object.defineProperty(Vue.prototype, '$monitor', {
        get: function () {
            return this._monitorRoot._monitor;
        },
    });
};
exports.install = install;
